export default __webpack_public_path__ + "static/media/DrukWM.f50ab8ed.woff";